import { Button, Flex, Menu, MenuButton, MenuButtonProps, MenuItem, MenuList } from '@chakra-ui/react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { FC } from 'react';

import ArrowIcon from '@/assets/icons/ic-down-chevron.svg';

import { OriginalsSeries } from '@/resources/OriginalsSeries';

interface ICoreNavigationMenuDropdownDesktopProps extends MenuButtonProps {
  navigationTitle: string;
  navigationItems: Array<OriginalsSeries>;
}

export const OriginalsMenuDropdownDesktop: FC<ICoreNavigationMenuDropdownDesktopProps> = ({
  navigationTitle,
  navigationItems,
  ...rest
}) => {
  const router = useRouter();

  function getHref(original: OriginalsSeries) {
    return `/originals/${original.id}-${original.slug}`;
  }

  return (
    <Flex display={{ base: 'none', lg: 'block' }}>
      <Menu computePositionOnMount variant="navigation" colorScheme="blackAlpha" placement="bottom-end" {...rest}>
        <MenuButton
          boxShadow={0}
          borderRadius={0}
          fontSize={{ base: '16px' }}
          fontWeight={700}
          px={4}
          py={4}
          _hover={{ textDecoration: 'underline' }}
          _focus={{ boxShadow: 'none', background: 'transparent' }}
          _focusVisible={{ outline: '2px solid', outlineColor: 'currentColor', outlineOffset: '2px' }}
          as={Button}
          rightIcon={<ArrowIcon />}
          background="transparent"
          _active={{ background: 'transparent' }}
        >
          {navigationTitle}
        </MenuButton>

        <MenuList color="white">
          {navigationItems &&
            navigationItems?.map((original: OriginalsSeries) => (
              <MenuItem
                textDecoration={router.asPath.startsWith(getHref(original)) ? 'underline' : null}
                _activeLink={{ color: 'red' }}
                as={NextLink}
                href={getHref(original)}
                key={original.id}
              >
                {original.author.firstName} {original.author.lastName}
              </MenuItem>
            ))}
        </MenuList>
      </Menu>
    </Flex>
  );
};
